import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GroupLinkService } from '../services/group-link.service';

/**
 * Interceptor to add the '3ddv-group-link' header to all HTTP requests
 * when a group link is active.
 */
@Injectable()
export class GroupLinkInterceptor implements HttpInterceptor {
  constructor(private groupLinkService: GroupLinkService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const groupLink = this.groupLinkService.getGroupLink();

    if (groupLink) {
      req = req.clone({
        setHeaders: {
          '3ddv-group-link': groupLink,
        },
      });
    }

    return next.handle(req);
  }
}
